import React from "react";
import "jquery-ui-bundle";
import "jquery/dist/jquery.min.js";
import $ from "jquery";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
class Edit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleSave = this.handleSave.bind(this);
  }

  handleSave() {
    $("#cover-spin").show(0);
    var actief;
    if ($("#e-area-active").is(":checked")) {
      actief = true;
    } else actief = false;
    var naam = $("#e-area-naam").val();
    var code = $("#e-area-code").val();
    var omschrijving = $("#e-area-omschrijving").val();

    var id = $("#area-identification").val();
    var model = {
      content: {
        algemeen: {
          code: code,
          actief: actief,
          naam: naam,
          omschrijving: omschrijving,
        },
      },
      identification: id,
    };

    omnimap
      .SaveOrEditAction(
        model,
        "PATCH",
        id,
        window.$catalog_management_units_token
      )
      .then((result) => {
        CallBackFunctions.BeheereenheidEditCallBack(
          window.$catalog_management_units_token
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async componentDidMount() {
    /*** Başlangıç tarihi değiştiğinde, bitiş tarihinin başlangıç tarihinden küçük olmamasını control eder ***/

    
  }

  render() {
    return (
      <div id="editSide" className="d-none">
        <div className="detail-title">Gebieden in Edit</div>
        <div className="clearfix">
          <div className="float-left mt-4">
            <a id="detail-button" className="back-page-link" role="button">
              <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar Gebieden
            </a>
          </div>
          <div className="float-right mt-0">
            <a
              id="edit_beheereenheid"
              className="button ok"
              onClick={this.handleSave}
            >
              Opslaan
            </a>
          </div>
          <div className="float-right mt-0 w-20">
            <a id="return-detail" className="button back">
              Annuleren
            </a>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Naam</div>
              <div className="box-title-2">
                <input id="e-area-naam" />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Code</div>
              <div className="box-title-2">
                <input id="e-area-code" />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Omschrijving</div>
              <div className="box-title-2">
                <input id="e-area-omschrijving" />
              </div>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Actief</div>
              <label className="switch">
                <input id="e-area-active" type="checkbox" />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
        </div>

        <input hidden id="area-identification" />
      </div>
    );
  }
}

export default Edit;
